import React, { useContext, useEffect, useState } from 'react';

import { CommentOutlined, PauseOutlined, FileDoneOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { Badge, Input, Popconfirm, Switch } from 'antd';
import SL_Button from '../../components/buttons/Button';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import monitory_room_grid_columns from './grid_columns/monitory_room_grid_columns';
import { CommentaryModal } from '../../components/modals/CommentaryModal'
import { displayMessage } from '../../services/helper';
import WaitingRoom from './WaitingRoom';

const { Search } = Input;

var last_row_id = null
var last_action = null
var last_field = null


export default function CreateControl(props) {
    const {
        setShowLoading, windowHeight,
        mobile_mode, user, setUser,
        enums, setEnums,
        interruptions, setInterruptions
    } = useContext(GeneralContext)

    const [currentControl, setCurrentControl] = useState(null)

    const [currentMonitors, setCurrentMonitors] = useState([])

    const [columns, setColumns] = useState(monitory_room_grid_columns)

    const [reloadGrid, setReloadGrid] = useState(false)
    const [isModalWaitingRoomVisible, setIsModalWaitingRoomVisible] = useState(false)
    const [isModalChangeMonitorVisible, setIsModalChangeMonitorVisible] = useState(false)
    const [isModalCommentaryVisible, setIsModalCommentaryVisible] = useState(false)


    const [haveMultipleSelect, setHaveMultipleSelect] = useState(false)
    const [haveSomethingSelected, setHaveSomethingSelected] = useState(false)

    const [areAllRowsSameStatus, setAreAllRowsSameStatus] = useState(false)
    const [allSelectedRowsRunning, setAllSelectedRowsRunning] = useState(false)

    const [waitingControls, setWaitingCntrols] = useState(null)



    const [controls, setControls] = useState([])


    useEffect(
        () => {
            if (!enums) {
                setShowLoading(true)
                api.auth.getEnums().then(
                    rs => setEnums(rs.data)
                )
                return
            }

            setColumns(
                monitory_room_grid_columns.concat(
                    [
                        pauseResume,
                        actionAddRemove({ ...enums?.EEventTypes?.CAMERA_POSITION }),
                        // actionAddRemove({ ...enums?.EEventTypes?.CORRECT_EXECUTION }),
                        // actionAddRemove({ ...enums?.EEventTypes?.CONCENTRATION_ACTIVITY }),
                        actionFinish,
                        actionComment,
                    ]
                )
            )

            loadControlsData()
            loadWaitingControls()

            startInterruptions()

            setShowLoading(false)

            return () => {
                // Anything in here is fired on component unmount.
                stopInterruptions()
            }
        }, [enums]
    )

    useEffect(() => {
        loadControlsData()
    }, [isModalWaitingRoomVisible, isModalChangeMonitorVisible])

    useEffect(() => {
        loadCurrentMonitorsData()
    }, [controls])

    const formatControlsToArrayIds = (controls) => {
        let payload = controls.map((control) => {
            return { id: control?.id }
        })
        return payload
    }

    const loadControlsData = async () => {
        try {
            setShowLoading(true)

            const rs = await api.dialy_controls.listExercising()
            gridRef.current.setSelectionModel([])
            setControls(rs.data)
        }
        finally {
            setShowLoading(false)
        }
    }

    const loadWaitingControls = async () => {
        try {
            setShowLoading(true)

            const rs = await api.dialy_controls.listWaiting()
            // gridRef.current.setSelectionModel([])
            setWaitingCntrols(rs.data)
        }
        finally {
            setShowLoading(false)
        }
    }

    const loadCurrentMonitorsData = () => {
        api.monitor.getCurrent().then(
            rs => setCurrentMonitors(rs.data)
        )
    }

    const startInterruptions = () => {
        interruptions.push(setInterval(() => loadCurrentMonitorsData(), 30000))
        setInterruptions(interruptions)
    }

    const stopInterruptions = () => {
        interruptions.forEach(i => clearInterval(i))
    }

    const DataGridProHeight = windowHeight * 0.7

    const gridRef = useGridApiRef()

    const handleOnOpenModalWaitingRoom = () => {
        setIsModalWaitingRoomVisible(true)
    }

    const handleOnCloseModalWaitingRoom = () => {
        setIsModalWaitingRoomVisible(false)
    }

    const handleRowChange = e => {
        setCurrentControl(e?.row)
    }

    const incrementControls = (control, field, value) => {
        if (controls?.length) {
            setControls(controls.map(
                c => {
                    if (c.id == control.id) {
                        c[field] = c[field] + value
                    }
                    if (c[field]) {

                    }
                    return c
                }
            ))
        }
    }

    const setControlFieldValue = (control, field, value) => {
        if (controls?.length) {
            setControls(controls.map(
                c => {
                    if (c.id == control.id) {
                        c[field] = value
                    }
                    return c
                }
            ))
        }
    }

    const handleOnClickMore = (control, field, code) => {
        setShowLoading(true)
        incrementControls(control, field, 1)

        let payload = { ...control, event_type: code, is_in_exercise_room: true }

        api.dialy_controls.addEvent(payload).then(
            rs => {
                setControlFieldValue(rs?.data[field])
                loadControlsData()
            },
            async err => {
                loadControlsData()
                let updatedUser = await api.user.get(user?.id)
                setUser(updatedUser.data)
            }
        )

        last_row_id = control.id
        last_field = field
        last_action = "more"

    }

    const handleOnClickLess = (control, field, code) => {
        if (control[field]) {
            setShowLoading(true)

            let payload = { ...control, event_type: code, is_in_exercise_room: true }

            api.dialy_controls.removeEvent(payload).then(
                rs => {
                    loadControlsData()
                    setControlFieldValue(rs?.data[field])
                },
                async err => {
                    loadControlsData()
                    let updatedUser = await api.user.get(user?.id)
                    setUser(updatedUser.data)
                }
            )

            last_row_id = control.id
            last_field = field
            last_action = "less"
        }
        else {
            alert(displayMessage('AVALIATION_WARNING'), 'error')
        }

    }

    const handleOpenCommentaryModal = (row) => {
        setCurrentControl(row)
        setIsModalCommentaryVisible(true)
    }

    const handleCloseCommentModal = () => {
        setIsModalCommentaryVisible(false)
    }

    const handleOnFinishExercise = async (controls) => {
        setShowLoading(true)
        try {
            let payload = formatControlsToArrayIds(controls)
            api.dialy_controls.finishExrcise(user.id, payload).then(
                rs => {
                    loadControlsData()
                    alert(displayMessage('END_EXERCISES_CONFIRMATION'))
                },
                async err => {
                    let updatedUser = await api.user.get(user?.id)
                    setUser(updatedUser.data)
                }
            )
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }

    }

    const reloadDataGrid = () => {
        setReloadGrid(!reloadGrid)
    }

    const handleWaitingRoom = async (patient) => {

        if (user.monitor_status == enums?.EMonitorStatus?.UNAVAILABLE?.code) {
            return alert(displayMessage('INDISPONIBLE_ARNING'))
        }

        const dialy_control = {
            "patient_id": patient?.id,
            "open_lip": 0,
            "camera_off": 0,
            "chewing": 0,
            "ended_at": 0,
            "exercise_done": 0,
            "camera_position": 0,
            "correct_execution": 0,
            "concentration_activity": 0,
        }
        try {
            setShowLoading(true)
            if (!controls.find(c => c?.Patient?.id == patient.id)) {
                let rs = await api.dialy_controls.create(dialy_control)
                loadControlsData()
            }

        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)

        } finally {
            handleOnCloseModalWaitingRoom()
            reloadDataGrid()
            setShowLoading(false)
        }
    }

    const handleOnChangeMultipleSelect = checked => {
        if (checked) {
            stopInterruptions()
        } else {
            startInterruptions()
        }
        setHaveMultipleSelect(checked)
    }

    const handleOnCancel = async (controls) => {
        try {
            setShowLoading(false);

            const id = user.id
            await api.dialy_controls.cancel(id, controls)
            loadControlsData()
            alert(displayMessage('CANCEL_MONITORY_SUCCESS'))
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false);
        }
    }

    const chooseBackgroundColor = (row_id, field) => {
        if (row_id == last_row_id && field == last_field) {

            if (last_action == "less") {
                return "#ffdddd"
            } else {
                return "#cfffdc"
            }
        }

        return null
    }

    const actionAddRemove = item => {
        return {
            field: item.field,
            headerName: item.description,
            width: user.user_type == enums.EUserTypes.MONITOR.code ? 140 : 100,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            style: { display: 'flex' },
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            padding: 5,
                            width: '100%',
                            height: '100%',
                            alignItems: 'center',
                            justifyContent: user.user_type == enums.EUserTypes.MONITOR.code ? 'space-evenly' : 'center',
                            background: chooseBackgroundColor(params.row.id, item.field),
                        }} >
                        {
                            user.user_type == enums.EUserTypes.MONITOR.code &&
                            <div>
                                <SL_Button
                                    style={{ background: '#ffdddd', borderColor: 'red', color: 'red', fontWeight: 'bold' }}
                                    className='items-center w-30 flex'
                                    onClick={() => handleOnClickLess(params.row, item.field, item.code)}
                                    shape="circle"
                                    disabled={params.row.paused_at == null}
                                    title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                                >
                                    -
                                </SL_Button>

                            </div>
                        }
                        <div style={{ fontWeight: 'bold', borderRadius: '5px', background: '#1b3663', color: 'white', height: 30, width: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {params.value}
                        </div>
                        {
                            user.user_type == enums.EUserTypes.MONITOR.code &&
                            <div>
                                <SL_Button
                                    style={{ background: '#cfffdc', borderColor: 'green', color: 'green', fontWeight: 'bold' }}
                                    className='items-center w-30 flex'
                                    shape="circle"
                                    onClick={() => handleOnClickMore(params.row, item.field, item.code)}
                                    disabled={params.row.paused_at == null}
                                    title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                                >
                                    +
                                </SL_Button>
                            </div>
                        }
                    </div>
                )
            },
            disableColumnSelector: true
        }
    }

    const pauseResume = {
        field: 'pause_resume_action',
        headerName: displayMessage('MONITORY_TATUS'),
        width: 160,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {

            if (params.row.paused_at == null) {
                return (
                    <SL_Button
                        style={{ background: '#6239bd', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                        shape="circle"
                        icon={<PlayCircleOutlined style={{ marginLeft: -1 }} />}
                        disabled={true}
                    >
                    </SL_Button>
                )
            }

            return (
                <SL_Button
                    style={{ background: 'gray', borderColor: 'lightgray', color: 'lightgray', fontWeight: 'normal' }}
                    shape="circle"
                    icon={<PauseOutlined />}
                    disabled={true}
                >
                </SL_Button>
            )
        },
        disableColumnSelector: true
    }

    const actionFinish = {
        field: 'finish',
        headerName: displayMessage('END_02'),
        width: 100,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottom"
                        title={displayMessage('COMFIRMATION_END_EXERCISE')}
                        onConfirm={() => handleOnFinishExercise([params.row])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >
                        <SL_Button
                            style={{ background: 'green', borderColor: 'lightgreen', color: 'lightgreen', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<FileDoneOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                        />
                    </Popconfirm>

                </div>
            )
        },
    }

    const actionComment = {
        field: 'commentary',
        headerName: displayMessage('COMMENT'),
        flex: 1,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <SL_Button
                        style={{ background: 'orange', borderColor: 'lightyellow', color: 'lightyellow', fontWeight: 'bold' }}
                        shape="circle"
                        onClick={() => handleOpenCommentaryModal(params.row)}
                        icon={<CommentOutlined />}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >

                    </SL_Button>

                </div>
            )
        },
    }

    const handleWhatIsSelectedInGrid = () => {
        const _controls = []
        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
        if (_controls.length > 0) {
            setHaveSomethingSelected(true)
            if (_controls.length > 1) {
                let allPausedAtNull = true;
                let allPausedAtNotNull = true;

                for (let i = 0; i < _controls.length; i++) {
                    if (_controls[i].paused_at !== null) {
                        allPausedAtNull = false;
                    } else {
                        allPausedAtNotNull = false;
                    }
                }

                if (allPausedAtNull == allPausedAtNotNull) {
                    setAreAllRowsSameStatus(false)
                    setAllSelectedRowsRunning(false)
                }
                else {
                    setAreAllRowsSameStatus(true)
                    _controls[0].paused_at == null && setAllSelectedRowsRunning(true)
                }
            }
            else {
                setAreAllRowsSameStatus(true)
                _controls[0].paused_at == null && setAllSelectedRowsRunning(true)
            }
        }
        else {
            setHaveSomethingSelected(false)
            setAllSelectedRowsRunning(false)
        }
    }

    return (
        <div>

            {
                isModalWaitingRoomVisible
                &&
                <WaitingRoom
                    isModalVisible={isModalWaitingRoomVisible}
                    handleOnCloseModal={handleOnCloseModalWaitingRoom}
                    refreshControls={loadControlsData}
                    handleWaitingRoom={handleWaitingRoom}
                    loadWaitingControls={loadWaitingControls}
                    waitingControls={waitingControls}
                    formatControlsToArrayIds={formatControlsToArrayIds}
                />
            }

            {
                isModalCommentaryVisible
                &&
                <CommentaryModal
                    isModalVisible={isModalCommentaryVisible}
                    handleOnCloseModal={handleCloseCommentModal}
                    currentControl={currentControl}
                />

            }

            <div className={`flex flex-1 justify-between flex-col gap-5`} >

                <div className={`flex flex-1  flex-row gap-5`}>
                    {
                        currentMonitors.map(
                            cm =>
                                <div
                                    style={{
                                        minWidth: 150,
                                        height: 70,
                                        border: '1px solid lightgray',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        WebkitBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        MozBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        boxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        paddingLeft: '8px',
                                        paddingRight: '8px'
                                    }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663', overflow: 'hidden' }}>{cm.first_name} {cm.last_name}</div>
                                    <div><strong>{displayMessage('PATIENTS')}:</strong> {cm?.DialyControls?.length}</div>
                                </div>
                        )
                    }
                </div>

                <div className={`flex flex-1 ${mobile_mode ? 'flex-col justify-center items-center' : 'flex-col'} justify-between gap-2`}>

                    <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row' }}>
                        <div className={`flex flex-1 ${mobile_mode ? 'flex-col justify-center items-center' : 'flex-row'}  gap-4`}>

                            <Badge count={waitingControls ? waitingControls?.length : 0} style={{ zIndex: 2, display: 'flex', flex: 1 }}>
                                <SL_Button
                                    type='primary'
                                    className={`items-center ${mobile_mode ? 'w-full' : 'w-30'} flex button-color`}
                                    onClick={handleOnOpenModalWaitingRoom}
                                    color={'#1b3663'}
                                    background={'#1b3663'}
                                    disabled={user.user_type != enums?.EUserTypes?.MONITOR?.code}
                                >
                                    {displayMessage('WAITING_ROOM')}
                                </SL_Button>
                            </Badge>
                            <SL_Button
                                type='primary'
                                className={`items-center ${mobile_mode ? 'w-full' : 'w-30'} flex button-color`}
                                onClick={() => loadControlsData()}
                                color={'#1b3663'}
                                background={'#1b3663'}
                            >
                                {displayMessage('UPDATE')}
                            </SL_Button>
                        </div>


                        <Switch
                            onChange={handleOnChangeMultipleSelect}
                            style={{ height: 30, width: mobile_mode ? '100%' : null, maxWidth: 180, marginTop: mobile_mode ? 10 : 0 }}
                            unCheckedChildren={displayMessage("ALLOW_MULTSELECT")}
                            checkedChildren={displayMessage("BLOCK_MULTSELECT")}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                        />

                    </div>
                    {
                        haveMultipleSelect &&
                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', columnGap: 15, marginTop: mobile_mode ? 5 : 0 }}>


                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column-reverse' : 'row', rowGap: mobile_mode ? 10 : '', columnGap: mobile_mode ? '' : 15 }} >
                                <Popconfirm
                                    zIndex={10001}
                                    placement="bottomLeft"
                                    title={displayMessage('COMFIRMATION_END_EXERCISE')}
                                    onConfirm={() => {
                                        const _controls = []
                                        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                        handleOnFinishExercise(_controls)
                                    }}
                                    okText={displayMessage('YES')}
                                    cancelText={displayMessage('NO')}
                                    disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                                >
                                    <SL_Button
                                        style={{ fontWeight: 'bold', maxWidth: mobile_mode ? 200 : '' }}
                                        danger={true}
                                        icon={<FileDoneOutlined />}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                                    >
                                        {displayMessage('END_EXERCISES')}
                                    </SL_Button>
                                </Popconfirm>
                            </div>
                        </div>
                    }
                </div>

                <div style={{
                    height: DataGridProHeight,
                    minHeight: 300,
                    WebkitBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                    MozBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                    boxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)"
                }} >
                    <DataGridPro
                        rows={controls}
                        apiRef={gridRef}
                        style={{ height: '70vh' }}
                        density={"comfortable"}
                        columns={columns}
                        pagination
                        pageSize={100}
                        onRowClick={handleRowChange}
                        disableMultipleSelection
                        checkboxSelection={haveMultipleSelect}
                        onSelectionModelChange={() => handleWhatIsSelectedInGrid()}

                    />
                </div>
            </div>
        </div>
    )
}